export class ApiError extends Error {
    constructor(
        message: string,
        public payload?: unknown,
        public status?: number,
        public context?: Record<string, any>,
        public requestOriginStack?: string | null
    ) {
        super(message);
        this.name = 'ApiError';
    }
}
